import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {Filter} from '@shared/models/filter.model';

export class CalendarFilterModel extends Filter {

    datetime_from: string;
    datetime_to: string;
    ald_reference_type: string;
    ald_reference_id: string;
    type: string[];
    place_ald_commodity_id: string;
    place_name: string;
    guest_name: string;


    constructor(model?: any) {
        super();
        if (!Utilities.isVoid(model)) {
            if (model.type) {
                this.type = model.type;
            }
            if (model.ald_reference_type) {
                this.ald_reference_type = model.ald_reference_type;
            }
            if (model.ald_reference_id) {
                this.ald_reference_id = model.ald_reference_id;
            }
            if (model.place_name) {
                this.place_name = model.place_name;
            }
            if (model.guest_name) {
                this.guest_name = model.guest_name;
            }
            if (!Utilities.isVoid(model.datetime_from) && model.datetime_from instanceof Date) {
                this.datetime_from = DateUtilities.getUTCStringFromDate((model.datetime_from as Date).setHours(0, 0, 0));
            } else {
                this.datetime_from = model.datetime_from;
            }
            if (!Utilities.isVoid(model.datetime_to) && model.datetime_to instanceof Date) {
                this.datetime_to = DateUtilities.getUTCStringFromDate((model.datetime_to as Date).setHours(23, 59, 59));
            } else {
                this.datetime_to = model.datetime_to;
            }
        }
    }

    newFilter(model?: any): CalendarFilterModel {
        return new CalendarFilterModel(model);
    }

    clone(): CalendarFilterModel {
        return new CalendarFilterModel(this);
    }

    public getFilterUrl(): string {
        let filterUrl = '?';
        if (!Utilities.isVoid(this.datetime_from)) {
            filterUrl += 'date_from=' + this.datetime_from;
        }
        if (!Utilities.isVoid(this.datetime_to)) {
            filterUrl += '&date_to=' + this.datetime_to;
        }
        if (!Utilities.isVoid(this.type)) {
            filterUrl += '&type=' + this.type;
        }
        if (!Utilities.isVoid(this.ald_reference_type)) {
            filterUrl += '&ald_reference_type=' + this.ald_reference_type;
        }
        if (!Utilities.isVoid(this.ald_reference_id)) {
            filterUrl += '&ald_reference_id=' + this.ald_reference_id;
        }
        if (!Utilities.isVoid(this.place_ald_commodity_id)) {
            filterUrl += '&place-ald_commodity_id=' + this.place_ald_commodity_id;
        }
        if (!Utilities.isVoid(this.place_name)) {
            filterUrl += '&place-name=' + this.place_name;
        }
        if (!Utilities.isVoid(this.guest_name)) {
            filterUrl += '&guest-name=' + this.guest_name;
        }
        return filterUrl;
    }

}
